<template>
  <div id="Declaration_preview" class="xv_modal">
    <div class="modal_content">
      <div class="hd_preview">
        <div class="header">
          <span class="title">Health Declarations</span>
          <button class="modal_close" @click="close_declaration_preview()">
            <span class="mdi mdi-close"></span>
          </button>
        </div>

        <div class="hd_preview_content declaration">
          <table class="hd_table">
            <thead>
              <tr>
                <th style="width:6%"></th>
                <th style="width:64%">Declaration</th>
                <th style="width:15%">Yes</th>
                <th style="width:15%">No</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>
                  Are you having?
                  <div class="row sub_declaration">
                    <div class="col-5">a) Fever</div>
                    <div class="col-7">
                      <b-form-checkbox
                        v-model="sub_declaration[0]"
                        disabled
                        id="checkbox-1"
                        name="checkbox-1"
                        value="check"
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <div class="row sub_declaration">
                    <div class="col-5">b) Cough</div>
                    <div class="col-7">
                      <b-form-checkbox
                        v-model="sub_declaration[1]"
                        disabled
                        id="checkbox-2"
                        name="checkbox-2"
                        value="check"
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <div class="row sub_declaration">
                    <div class="col-5">c) Sore throat</div>
                    <div class="col-7">
                      <b-form-checkbox
                        disabled
                        v-model="sub_declaration[2]"
                        id="checkbox-3"
                        name="checkbox-3"
                        value="check"
                      ></b-form-checkbox>
                    </div>
                  </div>
                </td>
                <td>
                  <b-form-radio name="1" value="A" v-model="declaration[0]" disabled></b-form-radio>
                </td>
                <td>
                  <b-form-radio name="1" value="B" v-model="declaration[0]" disabled></b-form-radio>
                </td>
              </tr>
              <tr>
                <td>2.</td>
                <td>
                  Is any family member diagnosed with the virus or under
                  quarantine?
                </td>
                <td>
                  <b-form-radio name="2" value="A" v-model="declaration[1]" disabled></b-form-radio>
                </td>
                <td>
                  <b-form-radio name="2" value="B" v-model="declaration[1]" disabled></b-form-radio>
                </td>
              </tr>
              <tr>
                <td>3.</td>
                <td>
                  Have you been served a government quarantine order or under
                  self quanratine
                </td>
                <td>
                  <b-form-radio name="3" value="A" v-model="declaration[2]" disabled></b-form-radio>
                </td>
                <td>
                  <b-form-radio name="3" value="B" v-model="declaration[2]" disabled></b-form-radio>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Declaration_preview",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      declaration: ["A", "A", "B"],
      sub_declaration: ["check", "", "check"]
    };
  },
  methods: {
    close_declaration_preview: function() {
      this.$modal.hide("declaration_preview");
    }
  }
};
</script>
